import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from '@/contexts/AuthContext';
import { ChatPanelProvider } from '@/contexts/ChatPanelContext';
import { AssistantPanelProvider } from '@/modules/assistant';
import { FeaturesProvider } from '@/contexts/FeaturesContext';
import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './globals.css';
import { Router } from './Router';

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <FeaturesProvider>
        <AuthProvider>
          <ChatPanelProvider>
            <AssistantPanelProvider>
              <Router />
            </AssistantPanelProvider>
          </ChatPanelProvider>
        </AuthProvider>
      </FeaturesProvider>
    </QueryClientProvider>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
